import styled from 'styled-components';

export const StyledWeeklyChart = styled.div``;

export const StyledChartBox = styled.div`
  width: 50%;
  height: 443px;
`;
